;(function() {
  "use strict"

  var _paginacion = function($timeout, $log) {
    return {
      restrict: "E",
      scope: {
        page: "=",
        onNext: "&",
        onPrev: "&"
      },

      template:
        '<div class="text-center small" ng-show="page"> ' +
        '	<div class="alert alert-xs alert-warning alert-inline2 alert-dismissable" ' +
        '		ng-hide="page.principio"> ' +
        '		<a href="javascript:void(0)" ' +
        '			ng-click="onPrev ({ npage : page.anterior})"> ' +
        '			<span class="glyphicon glyphicon-arrow-left"></span>mostrar anteriores ' +
        "		</a> " +
        "	</div> " +
        '	<div class="alert alert-xs alert-warning alert-inline2 alert-dismissable"> ' +
        "		Mostrando {{page.desc}} ( del {{page.inicial}} al {{page.final}} ) " +
        "	</div> " +
        '	<div class="alert alert-xs alert-warning alert-inline2 alert-dismissable" ' +
        '		ng-hide="page.ultimo"> ' +
        '		<a href="javascript:void(0)" ' +
        '			ng-click="onNext ({ npage : page.siguiente})"> ' +
        '			mostrar siguientes <span class="glyphicon glyphicon-arrow-right"></span> ' +
        "		</a> " +
        "	</div> " +
        "</div> ",

      link: function(scope, element, attrs) {
        $log.log("link paginación", scope)

        /*
				scope.prev = function (v) {
					$log.log("ejecutando ", v, scope);

					scope.onPrev ({ npage : v });
				}
				*/
      }
    }
  }

  angular
    .module("UP")
    .directive("uniPaginacion", ["$timeout", "$log", _paginacion])
})()
